import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import styles from './Tooltip.scss';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface ITooltip {
    className?: string;
    width?: number;
}

const ARROW_WIDTH = 7;

const Tooltip: React.FC<React.PropsWithChildren<ITooltip>> = ({ width = 300, className, children = '' }) => {
    const [layerWidth, setLayerWidth] = useState(width);
    const [isOpen, setIsOpen] = useState(false);
    const [isLeft, setIsLeft] = useState(false);

    const [left, setLeft] = useState(0);
    const [top, setTop] = useState(0);

    const infoElm = useRef(null);
    const tooltipElm = useRef(null);

    useEffect(() => {
        const elm = document.createElement('div');
        elm.className = styles.tooltipPortal;
        document.body.appendChild(elm);
        tooltipElm.current = elm;

        return () => {
            // ReactDOM.unmountComponentAtNode(tooltipElm.current);
            tooltipElm.current.remove();
        };
    }, []);

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                window.addEventListener('click', close);
                window.addEventListener('scroll', close);
                window.addEventListener('resize', close);
            }, 0);
        } else {
            window.removeEventListener('click', close);
            window.removeEventListener('scroll', close);
            window.removeEventListener('resize', close);
        }
        return () => {
            window.removeEventListener('click', close);
            window.removeEventListener('scroll', close);
            window.removeEventListener('resize', close);
        };
    }, [isOpen]);

    const close = () => {
        setIsOpen(false);
    };

    const toggleOpen = useCallback(() => {
        if (!isOpen) {
            const rect = (infoElm.current as HTMLElement).getBoundingClientRect();
            if (window.innerWidth / 2 < rect.left && window.innerWidth - rect.left < width + 40) {
                const lWidth = Math.min(width, rect.left - 12);
                setLayerWidth(lWidth);
                setIsLeft(true);
                setLeft(rect.left - lWidth - ARROW_WIDTH);
            } else {
                setLayerWidth(Math.min(width, window.innerWidth - (rect.left + rect.width + 12)));
                setIsLeft(false);
                setLeft(rect.left + rect.width + ARROW_WIDTH);
            }
            setIsOpen(true);
            setTop(rect.top + rect.height / 2);
        } else {
            setIsOpen(false);
        }
    }, [isOpen]);

    return (
        <div className={styles.tooltip + ' ' + className}>
            <a onClick={toggleOpen} ref={infoElm}>
                <InfoOutlinedIcon sx={{ fontSize: 12 }} />
            </a>

            {isOpen &&
                ReactDOM.createPortal(
                    <div className={styles.layer + (isLeft ? ` ${styles.left}` : '')} style={{ width: `${layerWidth}px`, top: `${top}px`, left: `${left}px` }}>
                        {children}
                    </div>,
                    tooltipElm.current
                )}
        </div>
    );
};

export default Tooltip;
